import "../scss/app.scss";
// or get all of the named exports for further usage
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;


console.log("Bootstrap Initialized");

import "../svg-icons/magnify.svg";

import "./main.js";
